<template>
    <div class="home" :style="charteVars">
        <div class="home-container">
            <div class="homeImage">
                <img :src="homeResource" alt="">
            </div>
            <div class="homeContent">
                <div class="homeText" :style="textStyle">
                    <h1 v-html="processText(homeImage.text)"></h1>
                </div>
                <div class="home-arrow" :style="launchStyle">
                    <img v-if="launchImage" :src="launchImage" alt="" class="launchImage">

                    <span @click="exitHomePage"><span v-html="processText(homeImage.launch_text)"></span><q-icon name="navigate_next"></q-icon></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import axios from "axios";
import { useRoute } from "vue-router";
import { useExhibitStyle } from "../../composables/useExhibitStyle";
import { useHomeLayout } from "../../composables/useHomeLayout";
export default {
    props: ["homeImage", "exhibitIdProps"],
    setup(props, ctx) {
        let homeResource = ref();
        const route = useRoute();
        const { cssVars, load: loadCharte } = useExhibitStyle(route.params.id ?? props.exhibitIdProps);
        const charteVars = computed(() => cssVars());
        const { textStyle, launchStyle } = useHomeLayout(() => props.homeImage);
        let exhibitId = ref();
        let launchResource = ref();
        let launchImage = ref();
        const start = async () => {
            console.log(props)
            exhibitId.value = route.params.id ?? props.exhibitIdProps;
            loadCharte();
            await getHomeFile();
            await getLaunchResource();
            if(launchResource.value?.launch_image_id) await getLaunchFile();
        };

        const processText = (text) => {
            if (!text) return text;
            return text.replace(/\\n/g, '\n');
        };

        const exitHomePage = () => {
            ctx.emit("exit");
        }

        const getHomeFile = async () => {
            try {
                let name = props.homeImage.name;
                let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${name}`;
                let response = await axios.get(url);
                var base64data = response.data;
                homeResource.value = base64data;
            } catch (error) {
                console.log(error);
            }
        };

        /*async function blobToData(blob, name) {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    let content = null;
                    let width = null;
                    let height = null;
                    const extension = name.split(".").pop().toLowerCase();
                    if (["jpg", "jpeg", "png", "gif", "bmp"].includes(extension)) {
                        const image = new Image();
                        image.src = reader.result;
                        image.onload = function () {
                            const aspectRatio = image.width / image.height;
                            width = Math.min(image.width, 200);
                            height = width / aspectRatio;
                            content = {
                                url: image.src,
                                width: width,
                                height: height
                            };
                            resolve(content);
                        };
                    } else if (["mp4", "webm", "avi", "mov", "mkv"].includes(extension)) {
                        const video = document.createElement("video");
                        video.src = URL.createObjectURL(blob);
                        video.addEventListener('loadedmetadata', function () {
                            const aspectRatio = video.videoWidth / video.videoHeight;
                            width = Math.min(video.videoWidth, 300);
                            height = width / aspectRatio;

                            content = {
                                url: video.src,
                                width: width,
                                height: height
                            };
                            resolve(content);
                        })
                    } else if (["mp3", "wav", "ogg", "m4a"].includes(extension)) {
                        content = {
                            url: URL.createObjectURL(blob),
                            width: null,
                            height: null
                        };
                        resolve(content);
                    } else {
                        resolve(content);
                    }
                };
                reader.readAsDataURL(blob);
            });
        }*/
        const getLaunchFile = async () => {
            try {
                let name = launchResource.value.name;
                let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${name}`;
                let response = await axios.get(url);
                var base64data = response.data;
                launchImage.value = base64data;
            } catch (error) {
                console.log(error);
            }
        };
        const getLaunchResource = async ( )=>{
            try {
                let url = `${process.env.VUE_APP_BASEURL}/launchImage/${exhibitId.value}`;
                let response = await axios.get(url);
                launchResource.value = response.data[0];

            } catch (error) {
                console.log(error);
            }
        }
        onMounted(start);

        return {
            homeResource,
            exhibitId,
            launchImage,
            launchResource,
            exitHomePage,
            processText,
            charteVars,
            textStyle,
            launchStyle

        }
    }

}
</script>
<style scoped>
.home {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    padding: 50px;
}

.home-container {
    display: flex;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    border-radius: 15px;
    max-height: 90%;
}

.homeImage {
    width: 50%;
    flex: 1;
}

.homeImage img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.homeContent {
    width: 50%;
    flex: 1;
    background: #fafafa; 
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 40px;
}

.homeText h1 {
    font-size: var(--expo-title-size, 40px);
    color: var(--expo-title-color, #333);
    font-family: var(--expo-title-font, inherit);
    font-weight: var(--expo-title-weight, bold);
    margin-bottom: 20px;
    white-space: pre-line;
}

.home-arrow {
    font-size: 40px;
    color: #007BFF;  /* couleur du bouton pour plus de contraste */
    cursor: pointer;
    animation-name: fadeArrow;
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
}

.home-arrow span {
    white-space: pre-line;
}

@keyframes fadeArrow {
    from {
        opacity: 0.6;
    }
    to {
        opacity: 1;
    }
}
.launchImage{
    max-height: 100px;
    width: auto;
    object-fit: contain;
    background: transparent;
    margin-right: 8px;
}
</style>
